import { render, staticRenderFns } from "./TopicSearch.vue?vue&type=template&id=471857f5&scoped=true&"
import script from "./TopicSearch.vue?vue&type=script&lang=js&"
export * from "./TopicSearch.vue?vue&type=script&lang=js&"
import style0 from "./TopicSearch.vue?vue&type=style&index=0&id=471857f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471857f5",
  null
  
)

export default component.exports